import api from "../../../api/api";

/* =========================
   GET COMPANY BY ID
========================= */
export const getCompanyById = (id: number) => {
  return api.get(`/company/v1/company/${id}/`);
};

/* =========================
   CREATE COMPANY
========================= */
export const createCompany = (data: any) => {
  return api.post("/company/v1/company/", data);
};

/* =========================
   UPDATE COMPANY
========================= */
export const updateCompany = (id: number, data: any) => {
  return api.put(`/company/v1/company/${id}/`, data);
};
